<!--
 * @Descripttion: 
 * @Author: voanit
 * @Date: 2021-07-15 19:10:38
 * @LastEditors: voanit
 * @LastEditTime: 2021-07-21 09:19:07
-->
<template>
  <div :class="['footer--wrap__fixed', collspan ? 'collspan' : '']">
    <div class="footer-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'footer-fixed',
  computed: {
    collspan() {
      return this.$store.state.menu.collapse
    }
  },
  mounted() {
    // const fn = (el, bool) => {
    //   el.children.forEach(element => {
    //     if (bool) {
    //       if (element.className.includes('el-button') && !element.className.includes('f-btn')) {
    //         element.className = element.className + ' el-button--small f-btn'
    //       } else if (element.children && element.children.length) {
    //         fn(element, true)
    //       }
    //     }
    //     if (element.className.includes('footer-content')) {
    //       return fn(element, true)
    //     } else {
    //       fn(element)
    //     }
    //   })
    // }
    // fn(this.$el)
  }
}
</script>

<style lang="scss">
.footer--wrap__fixed {
  position: fixed;
  padding: 12px 0;
  left: 0;
  right: 0;
  bottom: 0;
  text-align: center;
  background: #fff;
  z-index: 8;
  .footer-content {
    transform: translateX(120px);
  }
  &.collspan {
    .footer-content {
      transform: translateX(30px);
    }
  }
}
</style>
